import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions } from '@angular/material/dialog';

@Component({
  selector: 'app-referral-dialog',
  standalone: true,
  imports: [MatDialogActions],
  templateUrl: './referral-dialog.component.html',
  styleUrl: './referral-dialog.component.scss'
})
export class ReferralDialogComponent {
  constructor(private dialogRef: MatDialogRef<ReferralDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  onSuccessResponse() {
    this.dialogRef.close(true);     
  }

  onNegativeResponse() {
    this.dialogRef.close();
  }
}
